import * as React from 'react';
import { Text, TextArea, MultiSelect } from '../../components/forms';
import Section from '../../components/Section';
import { Product } from '../../product';
import ProductCategorySelect from '../../components/forms/ProductCategorySelect';
import HelpHint from '../../components/HelpHint';

type Props = {
  product: Product;
  setProduct: Function;
};

const setValue = (obj: Product, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

export default function GeneralProductInfo(props: Props) {
  const handleOnChange = setValue(props.product, props.setProduct);

  return (
    <React.Fragment>
      <Section title="General" id="general">
        <div className="flex flex-wrap">
          <div className="flex-auto w-70-ns w-100 pr2">
            <Text
              label="Name"
              field={['name']}
              id="name"
              defaultValue={props.product.name}
              onValueChange={handleOnChange}
            />
            <TextArea
              label="Description"
              field={['description_text']}
              id="description_text"
              defaultValue={props.product.description_text}
              onValueChange={handleOnChange}
            />
          </div>
          <div className="flex-auto w-30-ns w-100 pl2">
            <HelpHint>
              Note: The name and description should best describe the product
              you are selling. If the product is an electrical equipment i.e. a
              coffee grinder, please include any voltage specification to best
              inform the Filtru users.
              <br />
              <br />
              If you are offering your product in various sizes i.e. Coffee
              Beans in a bag of <strong>250g</strong> or <strong>1Kg</strong>,
              please add them as as <strong>Variants</strong> under one product.
              You can do so by clicking the <strong>Buying Options</strong> link
              at the top.
            </HelpHint>
          </div>
        </div>
      </Section>
      <Section title="Search">
        <div className="flex flex-wrap">
          <div className="flex-auto w-70-ns w-100 pr2">
            <MultiSelect
              label="Search keywords"
              field={['tags']}
              defaultValue={props.product.tags}
              id=""
              onValueChange={handleOnChange}
            />
          </div>
          <div className="flex-auto w-30-ns w-100 pl2">
            <HelpHint>
              Search keywords are used to help Filtru users discover your
              product. Make sure you add specific keywords such as varietal,
              origin or preferred method of brewing.
            </HelpHint>
          </div>
        </div>
      </Section>
      <Section title="Categories">
        <div className="flex flex-wrap">
          <div className="flex-auto w-70-ns w-100 pr2">
            <ProductCategorySelect
              label="Categories"
              field={['category_ids']}
              id="category_ids"
              defaultValue={props.product.category_ids}
              onValueChange={handleOnChange}
            />
          </div>
          <div className="flex-auto w-30-ns w-100 pl2">
            <HelpHint>
              Categories are how people will browse and discover products on
              Filtru. Make sure you add these to most accurate describe the
              product.
            </HelpHint>
          </div>
        </div>
      </Section>
    </React.Fragment>
  );
}
